<template>
    <div class="online-soil-report container-fluid" :class="{ 'theme-applied': theme_applied, 'media-print-shrink': has_recs && samples_per_page <= 5 }">
        <div class="online-soil-report-page" v-for="(page_samples, page) in pages">
            <report-header
                :report_data="report_data"
                :page_nbr="page+1"
                :total_pages="total_pages"
                :theme_applied="theme_applied"
            ></report-header>

            <div class="clearfix media-print-hidden m-t-15 m-b-15">
                <div class="pull-left dropdown btn-group m-r-10" v-if="page == 0" v-show="show_display_options">
                    <button type="button" data-toggle="dropdown" class="btn btn-lg btn-outline-gb m-t-0">
                        Display Options
                        <i class="fa fa-angle-down m-l-5"></i>
                    </button>
                    <ul class="dropdown-menu pull-right" style="width: 100%;">
                        <li v-if="theme_is_available">
                            <a href="#" @click="theme_applied = !theme_applied">
                                <i class="fa fa-paint-brush fa-fw"></i>
                                {{ theme_applied ? 'Remove' : 'Apply' }} Theme
                            </a>
                        </li>
                        <li v-show="has_recs">
                            <a href="#" @click="show_crop_removal = !show_crop_removal">
                                <i class="fa fa-leaf fa-fw"></i>
                                {{ show_crop_removal ? 'Hide' : 'Show' }} Crop Removals
                            </a>
                        </li>
                        <li v-show="format != 'online'" v-if="false">
                            <a href="#" @click="format = 'online'">
                                <i class="fa fa-file-text-o fa-fw"></i>
                                View Standard Report
                            </a>
                        </li>
                        <li v-show="format != 'firstform'" v-if="false">
                            <a href="#" @click="format = 'firstform'">
                                <i class="fa fa-bar-chart fa-fw"></i>
                                View Graph Report
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="pull-left dropdown btn-group" v-if="format == 'online' && page == 0 && (page_samples.length > 1 || pages.length > 1)">
                    <button type="button" data-toggle="dropdown" class="btn btn-lg btn-outline-gb m-t-0">
                        {{ samples_per_page }} Sample{{ samples_per_page > 1 ? 's' : '' }} Per Page
                        <i class="fa fa-angle-down m-l-5"></i>
                    </button>
                    <ul class="dropdown-menu pull-right" style="width: 100%;">
                        <li v-for="n in max_per_page">
                            <a href="#" @click="samples_per_page = n">
                                {{ n }} Sample{{ n > 1 ? 's' : '' }} Per Page
                            </a>
                        </li>
                    </ul>
                </div>

                <soil-recs-modal
                    btn_class="btn btn-lg btn-primary pull-right"
                    :label="(has_recs ? 'Alter' : 'Add') + ' Recommendations'"
                    :samples="samples"
                    :total_samples="samples.length"
                    :available_crops="available_crops"
                    max_recs="3"
                    @recs_calculated="update_recs"
                    @shown="getCropData"
                    v-if="page == 0"
                ></soil-recs-modal>
            </div>

            <div class="hor-separator media-print-hidden" v-if="page > 0"></div>

            <div class="m-b-5" style="position:relative">
                <div class="text-center text-bold text-uppercase">
                    Soil Analysis Report
                </div>

                <template v-if="theme_applied">
                    <em class="media-print-hidden p-l-15" style="position:absolute;left:0">
                        Analytical results provided by Midwest Laboratories, Inc.
                    </em>

                    <em class="media-screen-hidden" style="position:absolute;top:0;right:0;font-size:11px">
                        Analytical results provided by Midwest Laboratories, Inc.
                    </em>
                </template>

                <div class="media-print-hidden" style="position:absolute;top:0;right:0">
                    <div class="inline soil-rpt-header-label">Page</div>
                    <div class="inline soil-rpt-header-data">{{ page+1 }}/{{ total_pages }}</div>
                </div>
            </div>

            <div class="inline" style="min-width:100%">
                <template v-if="format == 'online'">
                    <results :samples="page_samples"></results>

                    <!-- IF RECS ARE ON SAMPE PAGE AS SAMPLE -->
                    <template v-if="has_recs && samples_per_page <= 5">
                        <div class="text-center text-bold text-uppercase m-t-15 m-b-5">
                            Soil Fertility Recommendations (Pounds Per Acre)
                        </div>

                        <recommendations-table
                                :samples="page_samples"
                                :show_crop_removal="show_crop_removal"
                                @edit_recs="edit_recs(page_samples[$event])"
                        ></recommendations-table>
                    </template>
                </template>

                <first-form :sample="page_samples[0]" v-else-if="format == 'firstform'"></first-form>
            </div>

            <div class="text-center text-bold">
                Recommendations generated are pre-plant recommendations. For sidedress application recommendations, contact the lab.
            </div>
        </div>

        <!-- ELSE IF RECS ARE INCLUDED SEPARATELY -->
        <div class="online-soil-report-page" v-for="(samples, page) in rec_pages" v-if="format == 'online'">
            <report-header
                :report_data="report_data"
                :page_nbr="pages.length+page+1"
                :total_pages="total_pages"
                :theme_applied="theme_applied"
            ></report-header>

            <div class="hor-separator media-print-hidden"></div>

            <div class="m-b-5" style="position:relative">
                <div class="text-center text-bold text-uppercase">
                    Soil Fertility Recommendations (Pounds Per Acre)
                </div>
                <div class="media-print-hidden" style="position:absolute;top:0;right:0">
                    <div class="inline soil-rpt-header-label">Page</div>
                    <div class="inline soil-rpt-header-data">{{ pages.length+page+1 }}/{{ total_pages }}</div>
                </div>
            </div>

            <recommendations-table
                :samples="samples"
                :show_crop_removal="show_crop_removal"
                @edit_recs="edit_recs(samples[$event])"
            ></recommendations-table>
        </div>

        <!-- ALTER RECS MODAL FOR INDIVIDUAL SAMPLE -->
        <soil-recs-modal
                btn_class="invisible"
                :samples="alter_recs_samples"
                :total_samples="samples.length"
                :available_crops="available_crops"
                ref="alter_sample_recs_modal"
                max_recs="3"
                @recs_calculated="update_recs"
                @shown="getCropData"
        ></soil-recs-modal>
    </div>
</template>

<script type="text/ecmascript-6">
    import ReportHeader from './online-soil-report/ReportHeader.vue';
    import Results from './online-soil-report/Results.vue';
    import RecommendationsTable from './online-soil-report/RecommendationsTable.vue';
    import FirstForm from './online-soil-report/FirstForm.vue';

    export default{
        props: {
            report_nbr: { default: 'XX-XXX-XXXX' }
        },
        components: {
            'report-header': ReportHeader,
            'results': Results,
            'recommendations-table': RecommendationsTable,
            'first-form': FirstForm
        },
        data () {
            return {
                samples_per_page: 10,
                report_data: {},
                theme_applied: false,
                theme_stylesheet: null,
                alter_recs_samples: [],
                available_crops: [],
                format: 'online',
                show_crop_removal: false
            }
        },
        watch: {
            format () {
                if (this.format == 'graphs') {
                    this.samples_per_page = 1;
                }
            },
            samples () {
                if (this.max_per_page < this.samples_per_page) {
                    this.samples_per_page = this.max_per_page;
                }
            },
            custom_theme () {
                if (!this.custom_theme) {
                    return;
                }

                if (!this.theme_stylesheet) {
                    this.theme_stylesheet = (function() {
                        var style = document.createElement("style");
                        style.appendChild(document.createTextNode(""));
                        document.head.appendChild(style);
                        return style.sheet;
                    })();
                }

                if (this.custom_theme.bg_color) {
                    this.theme_stylesheet.insertRule("" +
                        ".online-soil-report.theme-applied .soil-report-results thead th:not(.bg-transparent)," +
                        ".online-soil-report.theme-applied .soil-report-results tbody tr td.bg-primary-color" +
                        " { background-color: " + this.custom_theme.bg_color + " !important; }", 0);
                }

                if (this.custom_theme.font_color) {
                    this.theme_stylesheet.insertRule("" +
                        ".online-soil-report.theme-applied .soil-report-results thead th:not(.bg-transparent)," +
                        ".online-soil-report.theme-applied .soil-report-results tbody tr td.bg-primary-color" +
                        " { color: " + this.custom_theme.font_color + " !important }", 0);
                }

                if (this.custom_theme.border_color) {
                    let border_color = this.custom_theme.border_color;
                    if (border_color == this.custom_theme.bg_color) {
                        border_color = this.adjustHexColor(border_color, -45);
                    }

                    this.theme_stylesheet.insertRule("" +
                        ".online-soil-report.theme-applied .soil-report-results," +
                        ".online-soil-report.theme-applied .soil-report-results thead th," +
                        ".online-soil-report.theme-applied .soil-report-results tbody tr td" +
                        " { border-color: " + border_color + " !important }", 0);
                }
            }
        },
        computed: {
            show_display_options () {
                return this.theme_is_available || this.has_recs;
            },
            max_per_page () {
                let max = Math.min(10, this.samples.length);
                return Math.max(1, max);
            },
            total_pages () {
                return this.pages.length + this.rec_pages.length;
            },
            pages () {
                let samples = this.samples.length == 0 ? [{}] : this.samples;

                let pages = [];
                for (let page=0; page < samples.length; page += this.samples_per_page) {
                    pages.push(samples.slice(page, page + this.samples_per_page));
                }
                return pages;
            },
            rec_pages () {
                let pages = (this.samples_per_page <= 5 || this.samples.length <= 5) ? [] : this.pages;
                return pages.filter(page => page.filter(sample => sample.recs && sample.recs.length > 0).length > 0);
            },
            has_recs () {
                return this.samples.filter(sample => sample.recs && sample.recs.length > 0).length > 0;
            },
            samples () {
                return this.report_data.samples || [];
            },
            custom_theme () {
                return this.report_data.custom_theme || null;
            },
            theme_is_available () {
                return this.custom_theme ? true : false;
            }
        },
        methods: {
            getReportData () {
                if (this.report_nbr != 'XX-XXX-XXXX') {
                    this.$http.get('/reports/data/' + this.report_nbr).then((response) => {
                        this.report_data = response.data;
                        this.getCropData(this.formatPaidRecs);
                    })
                }
            },
            getCropData (success) {
                if (this.available_crops.length > 0) {
                    return;
                }

                this.$http.get('/soils/recommendations/crops?only_report_crops=true')
                    .then((response) => {
                        this.available_crops = response.data ? response.data : []

                        if (typeof success === 'function') success()
                    })
            },
            formatPaidRecs () {
                if (_.has(this.report_data,'samples')) {
                    this.report_data.samples.forEach(sample => {
                        let paid_recs = sample.paid_recs.map(rec => {
                            return Object.assign(rec, {
                                crop: this.available_crops.find(crop => crop.id == rec.crop),
                                previous: this.available_crops.find(crop => crop.id == rec.pcrop)
                            })
                        })

                        Vue.set(sample, 'paid_recs', paid_recs);
                        Vue.set(sample, 'recs', paid_recs);
                    })
                }
            },
            adjustHexColor (col, amt) {
                if (col[0] == "#") {
                    col = col.slice(1);
                }

                var num = parseInt(col,16);

                var r = (num >> 16) + amt;

                if (r > 255) r = 255;
                else if  (r < 0) r = 0;

                var b = ((num >> 8) & 0x00FF) + amt;

                if (b > 255) b = 255;
                else if  (b < 0) b = 0;

                var g = (num & 0x0000FF) + amt;

                if (g > 255) g = 255;
                else if (g < 0) g = 0;

                return "#" + (g | (b << 8) | (r << 16)).toString(16);

            },
            update_recs (recs) {
                recs.forEach(rec => {
                    let sample = this.samples.find(sample => sample.id == rec.id)

                    if (sample) {
                        Vue.set(sample, 'recs', rec.recs);
                    }
                })
            },
            edit_recs (sample) {
                this.alter_recs_samples = [sample];
                this.$refs.alter_sample_recs_modal.show_modal();
            }
        },
        mounted () {
            this.getReportData();
        }
    }
</script>



// WEBPACK FOOTER //
// online-soil-report.vue?6f0e520c